// Condição e forma de pagamento dos documentos (BDM-1208). O texto
// `payment_term`/`payment_form` continua sendo o rótulo impresso na proposta;
// os vínculos com o cadastro e a cópia das parcelas andam junto.

export const emptyPayment = {
    payment_term: '',
    payment_form: '',
    payment_term_id: null,
    payment_method_id: null,
    payment_installments: null,
};

export const paymentFromResource = resource => ({
    payment_term: resource?.payment_term ?? '',
    payment_form: resource?.payment_form ?? '',
    payment_term_id: resource?.payment_term_id ?? null,
    payment_method_id: resource?.payment_method_id ?? null,
    payment_installments: resource?.payment_installments ?? null,
});

export const paymentPayload = payment => ({
    payment_term: payment.payment_term ?? '',
    payment_form: payment.payment_form ?? '',
    payment_term_id: payment.payment_term_id,
    payment_method_id: payment.payment_method_id,
    payment_installments: payment.payment_installments,
});

// Mesma regra do backend (PaymentTerm::evenInstallments): duas casas e a
// primeira parcela leva a sobra, para a soma fechar 100.
export const evenInstallments = days => {
    const count = days.length;
    const base = Math.floor(10000 / count) / 100;
    const first = Math.round((100 - base * (count - 1)) * 100) / 100;

    return days.map((day, index) => ({ days: Number(day), percent: index === 0 ? first : base }));
};

// Mudar o percentual de uma parcela redivide o que sobra entre as seguintes,
// para quem preenche de cima para baixo (entrada de 30%, por exemplo) fechar
// 100 sem fazer conta. As anteriores ficam como estão.
export const rebalanceAfter = (installments, index) => {
    const following = installments.length - index - 1;
    const fixed = installments.slice(0, index + 1).reduce((sum, installment) => sum + (Number(installment.percent) || 0), 0);
    const remaining = Math.round((100 - fixed) * 100) / 100;

    if (following === 0 || installments[index].percent === '' || remaining <= 0) return installments;

    const base = Math.floor(remaining * 100 / following) / 100;
    const first = Math.round((remaining - base * (following - 1)) * 100) / 100;

    return installments.map((installment, current) => {
        if (current <= index) return installment;
        return { ...installment, percent: current === index + 1 ? first : base };
    });
};

const isEvenSplit = installments => {
    const even = evenInstallments(installments.map(installment => Number(installment.days) || 0));
    return installments.every((installment, index) => Math.abs(Number(installment.percent) - even[index].percent) < 0.001);
};

export const installmentsPercentSum = installments =>
    Math.round((installments ?? []).reduce((sum, installment) => sum + (Number(installment.percent) || 0), 0) * 100) / 100;

const nameForDays = days => (days.length === 1 && days[0] === 0 ? 'À vista' : `${days.join('/')} dias`);

export const formatPercent = percent => String(Math.round(Number(percent) * 100) / 100).replace('.', ',');

// Espelho de HasPaymentCondition::labelForInstallments, para a tela mostrar o
// rótulo antes de salvar.
export const labelForInstallments = installments => {
    if (isEvenSplit(installments)) return nameForDays(installments.map(installment => Number(installment.days)));

    return installments
        .map(installment => {
            const when = Number(installment.days) === 0 ? 'à vista' : `em ${Number(installment.days)} dias`;
            return `${formatPercent(installment.percent)}% ${when}`;
        })
        .join(' + ');
};

export const describeInstallments = installments =>
    (installments ?? []).map(installment => `${formatPercent(installment.percent)}% em ${installment.days}d`).join(' · ');
